import React from 'react';

import style from './style.module.scss';

interface Props extends React.HTMLAttributes<SVGSVGElement> {
  animate: boolean;
}

export default ({ className, animate, ...props }: Props) => {
  return (
    <svg
      className={[style.svg, animate ? style.animate : null, className].join(
        ' '
      )}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 24 24"
      x="0px"
      y="0px"
    >
      <g transform="translate(-1.2066101,0.68593252)">
        <path
          className={style.valve}
          d="m 14.930771,8.1700168 v 0.811402 c 0,0.1369255 -0.112188,0.2476057 -0.250972,0.2476057 -0.138789,0 -0.250974,-0.1106802 -0.250974,-0.2476057 V 8.1700168 C 14.279497,8.084345 14.177852,7.9263732 14.177852,7.7433929 c 0,-0.1827325 0.101647,-0.3407043 0.250973,-0.4263761 V 6.5053671 c 0,-0.1366778 0.112188,-0.2476048 0.250974,-0.2476048 0.138787,0 0.250972,0.110927 0.250972,0.2476048 v 0.8116497 c 0.149329,0.085672 0.250973,0.2436436 0.250973,0.4263761 0,0.1829803 -0.101648,0.3409521 -0.250973,0.4266239 M 15.432717,4.7721313 H 13.92688 c -0.138788,0 -0.250973,0.1109276 -0.250973,0.2476052 v 5.4473125 c 0,0.136927 0.112188,0.247606 0.250973,0.247606 h 1.505837 c 0.138788,0 0.250973,-0.11068 0.250973,-0.247606 V 5.0197364 c 0,-0.1366781 -0.112188,-0.2476052 -0.250973,-0.2476052"
          style={{
            fill: 'currentColor',
            fillOpacity: 1,
            fillRule: 'evenodd',
            stroke: 'none',
            strokeWidth: 0.24928327,
          }}
        />
        <circle
          r="4.9085407"
          cy="15.817908"
          cx="4.7994552"
          style={{
            opacity: 1,
            fill: 'none',
            fillOpacity: 1,
            stroke: 'currentColor',
            strokeWidth: 1.10007811,
            strokeMiterlimit: 4,
            strokeDasharray: 'none',
            strokeOpacity: 1,
          }}
          transform="matrix(0.71186675,-0.70231455,0.71186675,0.70231455,0,0)"
        />
        <rect
          style={{
            opacity: 1,
            fill: 'currentColor',
            fillOpacity: 1,
            stroke: 'none',
            strokeWidth: 0.41717631,
            strokeMiterlimit: 4,
            strokeDasharray: 'none',
            strokeOpacity: 1,
          }}
          width="1.6209245"
          height="5.8688645"
          x="4.6099491"
          y="22.077719"
          ry="0.13262978"
          transform="matrix(0.6990127,-0.71510926,0.6990127,0.71510926,0,0)"
        />
        <g transform="matrix(0.59820436,0,0,0.59820436,-0.33155742,7.7382762)">
          <path
            style={{
              fill: 'currentColor',
              fillOpacity: 1,
              strokeWidth: 0.30993807,
            }}
            d="m 13.013405,8.862631 c 0,0.6818636 0.557889,1.208759 1.208759,1.208759 h 2.727454 L 13.013405,6.135176 Z"
          />
          <path
            style={{
              fill: 'currentColor',
              fillOpacity: 1,
              strokeWidth: 0.30993807,
            }}
            d="m 14.222164,10.381328 c -0.836833,0 -1.518697,-0.6818642 -1.518697,-1.518697 V 6.135176 H 6.0707924 c -0.65087,0 -1.2087585,0.5578885 -1.2087585,1.2087584 V 19.803445 c 0,0.681863 0.5578885,1.208758 1.2087585,1.208758 h 9.6390736 c 0.681864,0 1.208759,-0.557888 1.208759,-1.208758 V 10.381328 Z M 10.254956,7.9328168 h 1.208759 V 8.1807673 H 10.998808 V 9.5135009 H 10.719863 V 8.1807673 h -0.464907 z m -2.7584486,0 H 8.6122845 V 8.1807673 H 7.7754517 V 8.5836867 H 8.519303 V 8.8316372 H 7.7754517 V 9.2655505 H 8.6432783 V 9.5135009 H 7.4965074 Z M 6.7526561,9.5135009 H 6.4737118 V 8.1807673 H 6.0088048 V 7.9328168 H 7.2175632 V 8.1807673 H 6.7526561 Z M 9.1081854,19.5245 H 6.9076251 v -2.20056 h 2.2005603 z m 0,-3.223355 H 6.9076251 v -2.200561 h 2.2005603 z m 0,-3.223356 H 6.9076251 V 10.877228 H 9.1081854 Z M 9.5111048,9.5135009 c -0.2479504,0 -0.4649071,-0.092981 -0.6508699,-0.2479505 l 0.154969,-0.1859629 c 0.1549691,0.1239753 0.3099381,0.2169568 0.4959009,0.2169568 0.092981,0 0.1549691,-0.030994 0.2169567,-0.061988 0.061988,-0.030994 0.061988,-0.092982 0.061988,-0.1549691 0,-0.061988 -0.030994,-0.092981 -0.061988,-0.154969 C 9.6660739,8.8936248 9.6040862,8.862631 9.480111,8.8316372 9.3561358,8.8006434 9.2631544,8.7696496 9.2321606,8.7696496 9.170173,8.7386558 9.1081854,8.707662 9.0771915,8.6766682 8.9842101,8.6146805 8.9532163,8.4907053 8.9532163,8.3667301 c 0,-0.154969 0.061988,-0.2479505 0.1549691,-0.3409319 0.092981,-0.092981 0.2479504,-0.1239752 0.4029194,-0.1239752 0.092981,0 0.1859629,0.030994 0.3099381,0.061988 0.092981,0.030994 0.1859631,0.092981 0.2479501,0.1239752 L 9.9140243,8.2737487 C 9.8520367,8.2427549 9.7900491,8.2117611 9.7280615,8.1807673 9.6350801,8.1497734 9.5730924,8.1497734 9.480111,8.1497734 c -0.061988,0 -0.154969,0.030994 -0.1859628,0.061988 -0.061988,0.030994 -0.061988,0.092981 -0.061988,0.1549689 0,0.061988 0.030994,0.1239753 0.061988,0.154969 0.061988,0.030994 0.154969,0.061988 0.309938,0.1239752 0.1549691,0.030994 0.2789443,0.092981 0.3719257,0.1549692 0.092981,0.061988 0.1239751,0.1859628 0.1239751,0.309938 0,0.1239753 -0.06199,0.2479505 -0.1549689,0.3409319 -0.154969,0.030994 -0.2789442,0.061988 -0.4339133,0.061987 z M 14.904027,18.780649 H 10.038 v -0.743851 h 4.835033 v 0.743851 z m 0,-3.223356 H 10.038 v -0.743851 h 4.835033 v 0.743851 z m 0,-3.192362 H 10.038 V 11.62108 h 4.835033 v 0.743851 z"
          />
        </g>
      </g>
    </svg>
  );
};
